import { render } from "./ButtonBlue.vue?vue&type=template&id=934b2652"
import script from "./ButtonBlue.vue?vue&type=script&lang=js"
export * from "./ButtonBlue.vue?vue&type=script&lang=js"
script.render = render

export default script